import React, { useContext, useEffect, useState } from 'react';
import { Grid, Row } from "react-bootstrap";
import { Card } from 'components/Card/Card.jsx';
import BeatLoader from "react-spinners/BeatLoader";
import Cookies from 'universal-cookie';
import cookieManagement from '../utilities/Cookie';
import { FetchAPI } from 'api/fetch';
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { loopBackDomain, loopBackPort } from "environment/environment";
import { PostAPI } from "api/post.js";
const cookies = new Cookies();
let logoName = cookies.get('clientSubDomain') === undefined ? cookieManagement.setClientSubDomainToCookie() : cookies.get('clientSubDomain');

const Wallet = props => {
    let [featureBlueprint, setFeatureBlueprint] = useContext(FeatureBlueprintContext);
    let [walletVal, setWalletVal] = useState({});
    let [pageLayoutData, setPageLayoutData] = useState('undefined');
    let pageLayoutDataContext = (featureBlueprint.data === undefined) ? 'undefined' : featureBlueprint.data.featureBlueprintymlData.pageTypes[0].bodyLayout;
    let [globalLoadIndicator, setGlobalLoadIndicator] = useContext(GlobalLoadIndicator);

    useEffect(() => {
        (async () => {
            if (pageLayoutData !== 'undefined') {
                let activeClientID = localStorage.getItem('activeWalletClientCustomerID');
                let activeClientHeader = localStorage.getItem('activeWalletClientToken');
                let params = new URLSearchParams({ customer_id: activeClientID }).toString();
                let endpoint = pageLayoutData[0].apiEndPoint;
                let getUrl = (`${endpoint}?${params.toString()}`);
                const token = { clientToken: activeClientHeader }
                const walletDataValues = await FetchAPI(getUrl, token);
                const walletDataValuesJson = await walletDataValues.json();
                setWalletVal(walletDataValuesJson.data);
                if (walletDataValues.status == 200) {
                }
            }
        })()

    }, [pageLayoutData]);

    useEffect(() => {
        (async () => {
            let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/getFeatureBlueprint';
            const payload = {
                pageTypeID: 9,
                featureID: 1
            };

            cookies.set('feature_id', 1, { path: '/' });
            await setGlobalLoadIndicator('1');
            let response = await PostAPI(url, payload);
            await setFeatureBlueprint(response);
            await setGlobalLoadIndicator('2');
        })()
    }, [])

    useEffect(() => {
        if (globalLoadIndicator == '2') {
            setPageLayoutData(pageLayoutDataContext);
        } else if (globalLoadIndicator == '1') {
            setPageLayoutData('undefined');
        }
    }, [globalLoadIndicator]);

    const WalletCards = ({ logoName, walletData }) => {
        return (<Grid fluid>
            <Row>
                <Card style={{ fontSize: '12px' }}
                    title="Wallet"
                    title2="Statement"
                    content={
                        <div>
                            <div className="row">
                                <div className="col-md-6">
                                    <Card
                                        stats={(walletData.totalPo) ? "Total PO's : " + walletData.totalPo : "Total PO's : NA"}
                                        statsIcon="fa fa-qrcode"
                                        content={
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    fontSize: '45px'
                                                }}
                                            >
                                                <div className="col-md-6">
                                                    <i className="fa fa-qrcode"></i>
                                                </div>
                                                <div className="col-md-6">
                                                    <span style={{ fontSize: '24px', marginLeft: '50px' }}>{(walletData.totalQty) ? walletData.totalQty : 'NA'}</span>
                                                </div>
                                            </div>
                                        }
                                    />
                                </div>

                                <div className="col-md-6">
                                    <Card
                                        stats=" IOT's Generated"
                                        statsIcon="fa fa-bookmark"
                                        content={
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    fontSize: '45px'
                                                }}
                                            >
                                                <div className="col-md-6">
                                                    <i className="fa fa-bookmark"></i>
                                                </div>
                                                <div className="col-md-6">
                                                    <span style={{ fontSize: '24px', marginLeft: '50px' }}>{(walletData.totalGenerated) ? walletData.totalGenerated : 'NA'}</span>
                                                </div>
                                            </div>
                                        }
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <Card
                                        stats="Balance Count"
                                        statsIcon="fa fa-bookmark-o"
                                        content={
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    fontSize: '45px'
                                                }}
                                            >
                                                <div className="col-md-6">
                                                    <i className="fa fa-bookmark-o"></i>
                                                </div>
                                                <div className="col-md-6">
                                                    <span style={{ fontSize: '24px' }}>{(walletData.pendingIds) ? walletData.pendingIds : 'NA'}</span>
                                                </div>
                                            </div>
                                        }
                                    />
                                </div>

                                <div className="col-md-4">
                                    <Card
                                        stats="Drawn Count"
                                        statsIcon="fa fa-download"
                                        content={
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    fontSize: '45px'
                                                }}
                                            >
                                                <div className="col-md-6">
                                                    <i className="fa fa-download"></i>
                                                </div>
                                                <div className="col-md-6">
                                                    <span style={{ fontSize: '24px' }}>{(walletData.drawnCount) ? walletData.drawnCount : 'NA'}</span>
                                                </div>
                                            </div>
                                        }
                                    />
                                </div>


                                <div className="col-md-4">
                                    <Card
                                        stats="Free Count"
                                        statsIcon="fa fa-download"
                                        content={
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    fontSize: '45px'
                                                }}
                                            >
                                                <div className="col-md-6">
                                                    <i className="fa fa-download"></i>
                                                </div>
                                                <div className="col-md-6">
                                                    <span style={{ fontSize: '24px' }}>{(walletData.freeCount) ? walletData.freeCount : 'NA'}</span>
                                                </div>
                                            </div>
                                        }
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-3">
                                    <Card
                                        stats="Total Used"
                                        statsIcon="fa fa-bar-chart-o"
                                        content={
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    fontSize: '45px'
                                                }}
                                            >
                                                <div className="col-md-4">
                                                    <i className="fa fa-bar-chart-o"></i>
                                                </div>
                                                <div className="col-md-8">
                                                    <span style={{ fontSize: '24px' }}> {(walletData.totalUsed) ? walletData.totalUsed : 'NA'}</span>
                                                </div>
                                            </div>
                                        }
                                    />
                                </div>

                                <div className="col-md-3">
                                    <Card
                                        stats="Primary"
                                        statsIcon="fa fa-file"
                                        content={
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    fontSize: '45px'
                                                }}
                                            >
                                                <div className="col-md-4">
                                                    <i className="fa fa-file"></i>
                                                </div>
                                                <div className="col-md-8">
                                                    <span style={{ fontSize: '24px' }}>{(walletData.primaryIds) ? walletData.primaryIds : 'NA'}</span>
                                                </div>
                                            </div>
                                        }
                                    />
                                </div>

                                <div className="col-md-3">
                                    <Card
                                        stats="Cartons"
                                        statsIcon="fa fa-cube"
                                        content={
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    fontSize: '45px'
                                                }}
                                            >
                                                <div className="col-md-4">
                                                    <i className="fa fa-cube"></i>
                                                </div>
                                                <div className="col-md-8">
                                                    <span style={{ fontSize: '24px' }}>{(walletData.cartons) ? walletData.cartons : 'NA'}</span>
                                                </div>
                                            </div>
                                        }
                                    />
                                </div>

                                <div className="col-md-3">
                                    <Card
                                        stats="TP"
                                        statsIcon="fa fa-truck"
                                        content={
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    fontSize: '45px'
                                                }}
                                            >
                                                <div className="col-md-4">
                                                    <i className="fa fa-truck"></i>
                                                </div>
                                                <div className="col-md-8">
                                                    <span style={{ fontSize: '24px' }}>{(walletData.tps) ? walletData.tps : 'NA'}</span>
                                                </div>
                                            </div>
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    }
                >
                </Card>
            </Row>
        </Grid>);
    };

    return (
        (pageLayoutData != 'undefined') ?
            <div className="content">
                <WalletCards
                    logoName={logoName}
                    walletData={walletVal}
                />
            </div>
            : <div className="content">
                <Grid fluid>
                    <div className="text-center" style={{ margin: "200px" }}><BeatLoader size={15} margin={3} color={"#3C423C"} /></div>
                </Grid>
            </div>
    );
}

export default Wallet;
